import React from 'react';
import {connect} from "react-redux";
import CustomPaper from "../../../shared/utils/CustomPaper";
import PDFIcon from 'material-ui/svg-icons/image/picture-as-pdf';
import AuthService from '../../../../services/AuthService';
import ReactTable from "react-table";
import reactTableProps from '../../../shared/utils/reactTableProps';
import pdfHandler from "../../../shared/utils/pdfHandler";



class EtatDesLieux extends React.Component {

    constructor(props){
        super(props);
        this.Auth = new AuthService();
        this.downloadFile = this.downloadFile.bind(this);
    }



    downloadFile(id){
       this.Auth.fetch("/services/pdf/etat_des_lieux/"+id, {responseType: 'arraybuffer'})
           .then(resp=>pdfHandler(resp.data, 'etat_des_lieux.pdf'));
    }


    render() {
        return (
            <CustomPaper title="État des lieux">
                <ReactTable

                    filterable
                    defaultFilterMethod={(filter, row) => {
                        let row_value = row[filter.id].toUpperCase();
                        let filter_value = filter.value.toUpperCase();
                        return (row_value.indexOf(filter_value) > -1);
                    }
                    }
                    {...reactTableProps}
                    data={this.props.salaries}
                    columns=
                        {
                            [
                                {
                                    Header: "Salarié",
                                    columns: [
                                        {
                                            Header: "Numéro",
                                            accessor: "num_salarie",
                                            maxWidth:150
                                        },
                                        {
                                            Header: "Nom",
                                            accessor: "nom",
                                            maxWidth:150
                                        },
                                        {
                                            Header: "Prénom",
                                            accessor: "prenom",
                                            maxWidth:150
                                        },
                                    ]
                                },
                                {
                                    Header: "Téléchargement",
                                    sortable:false,
                                    filterable:false,
                                    columns: [
                                        {
                                            filterable:false,
                                            sortable:false,
                                            accessor: "id",
                                            Cell: row => (
                                                <div
                                                    style={{cursor:'pointer', textAlign:'center'}}
                                                    onClick={()=>this.downloadFile(row.value)}>
                                                    Télécharger le fichier <PDFIcon/>
                                                </div>
                                            )
                                        }

                                    ]
                                }
                    ]}
                    defaultPageSize={10}
                    className="-striped -highlight"
                />
            </CustomPaper>
        );
    }
}

function mapStateToProps(store) {
    return {
        salaries:store.entreprise.entreprise_infos.salaries
    }
}

export default connect(mapStateToProps)(EtatDesLieux);


// WEBPACK FOOTER //
// ./src/components/entreprise/bodies/salaries/EtatDesLieux.js